<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>用户管理</el-breadcrumb-item>
          <el-breadcrumb-item>用户列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="5" class="display-row">
            <div class="query-title">用户姓名:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.realName" size="small"
                @keyup.enter.native="searchCustomer">
              </el-input>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title">用户ID:</div>
            <div class="flex1">
              <!--<el-input placeholder="请输入内容" clearable v-model="queryInfo.userName" size="small"
                @keyup.enter.native="searchCustomer">
              </el-input>-->
              <search-user-id v-model="queryInfo.userName"></search-user-id>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">代购权限:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.hotboomFlag" placeholder="请选择" size="small" clearable>
                <el-option v-for="item in hotboomOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">负责人:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.staffUserId" size="small" value-key="userId" filterable placeholder="请选择负责人姓名">
                <!--:label="item.realName + '(' + item.userName + ')'"-->
                <el-option
                    v-for="item in staffList"
                    :key="item.userId"
                    :label="item.realName"
                    :value="item.userId"
                >
                  <div>
                    {{ item.realName }}
                    <!--<span>({{ item.userName }})</span>-->
                  </div>
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px">
              <el-button class="search-btn btn-gray" @click="clearConditions">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchCustomer">搜索</el-button>
              <el-button class="search-btn btn-green" @click="distribution">分配</el-button>
              <el-button class="search-btn btn-green" @click="exportAction">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :data="customerList" :header-cell-style="tableStyle.headerStyle" v-loading="isLoading"
          :cell-style="tableStyle.cellStyle" border ref="multipleTable" @select="tableSelect" @select-all="tableSelectAll"
          height="550">
          <el-table-column align="center" type="selection"> </el-table-column>
          <el-table-column align="center" type="index" label="序号" width="40">
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button class="list-btn-four btn-green" @click="costDeal(scope.row)">费用处理</el-button><br />
              <el-button class="list-btn-four btn-blue" @click="reply(scope.row)">提醒</el-button><br />
              <el-button class="list-btn-four btn-deepblue" @click="changeStatus(scope.row)">
                {{ scope.row.userFlag == 0 ? "禁用" : "启用" }}</el-button><br />
              <el-button class="list-btn-four btn-deepblue" @click="changeHotboomFlag(scope.row)">
                {{ scope.row.hotboomFlag == 0 ? "开启代购" : "关闭代购" }}</el-button><br />
<!--              <el-button class="list-btn-four btn-green" @click="costSetting(scope.row)">-->
<!--                费用配置-->
<!--              </el-button>-->
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="用户ID">
            <template v-slot="scope">
              <span>{{ scope.row.userName }}</span><br>
              <span>{{ scope.row.emailAddress }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="realName" label="用户姓名">
          </el-table-column>
          <el-table-column prop="balance" width="110" align="center" :index="indexMethod" sortable label="余额（元）">
          </el-table-column>
          <el-table-column prop="realName" label="会员等级" align="center" width="180">
            <template v-slot="{ row }">
              <p style="text-align: left;display: flex;" v-if="row.levelName">
                <span class="oneStr">会员等级：{{ row.levelName }}</span>
                <el-popover
                  placement="top"
                  title="提示"
                  trigger="hover"
                >
                  <!--class="pop-flex"-->
                  <div><span>会员等级：</span>{{row.levelName}}</div>
                  <div><span>减免会员费期限：</span>{{row.monthReduction}}</div>
                  <div><span>每月会员费（￥）：</span>{{row.membershipFee}}</div>
                  <div><span>代购手续费比率（%）：</span>{{row.commission}}</div>
                  <i class="el-icon-warning form-icon" slot="reference"></i>
                </el-popover>
              </p>
              <p style="text-align: left;" v-if="row.levelTime">
                绑定时间：{{ row.levelTime.split(' ')[0] }}
              </p>
              <!--:disabled="row.creditLimitApply && row.creditLimitApply > 0"-->
              <el-button
                class="mt5"
                size="small"
                type="primary"
                :disabled="row.creditLimitApply && row.creditLimitApply > 0"
                @click="setLevel(row)"
              >
                修改
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" sortable width="100" :index="indexMethod"
            :formatter="dateFormatYMDHMS">
          </el-table-column>
          <el-table-column prop="staffUserRealName" label="负责人" align="center">
          </el-table-column>
          <el-table-column prop="userFlag" label="用户状态" align="center" :index="indexMethod" sortable :formatter="statusFormatter">
          </el-table-column>
          <el-table-column prop="hotboomFlag" label="代购权限" align="center" :formatter="hotboomFormatter">
          </el-table-column>
          <el-table-column prop="latestSigninTime" label="最新登录时间" align="center" sortable width="160" :index="indexMethod">
            <template v-slot="scope">
              {{ scope.row.latestSigninTime | dateFormatToSecond }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </table-con>
    <!-- 分配用户 -->
    <el-dialog title="分配用戶" :visible.sync="distributionVisible" width="30%" @close="distributionDialogClose">
      <el-form label-width="120px" class="add-role-form">
        <el-form-item label="负责人：">
          <el-select v-model="distributionInfo.staffUserId" value-key="userId" filterable placeholder="输入用户名进行搜素">
            <!--<el-option v-for="item in staffList" :key="item.userId" :label="item.userName" :value="item.userId">
            </el-option>-->
            <el-option
              v-for="item in staffList"
              :key="item.userId"
              :label="item.realName + '(' + item.userName + ')'"
              :value="item.userId"
            >
              <div>
                {{ item.realName }}
                <span>({{ item.userName }})</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="closeDistributionDialog">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="confirmDistribution">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 费用处理 -->
    <el-dialog title="费用处理" :visible.sync="costDealVisible" width="30%" @close="costDealDialogClose">
      <el-form label-width="120px" :model="costDealInfo" ref="costDealForm" :rules="costDealRole">
        <el-form-item label="收支类型：" prop="typeDetail">
          <el-radio-group v-model="costDealInfo.typeDetail">
            <el-radio :label="1">充值</el-radio>
            <el-radio :label="4">赔偿</el-radio>
            <el-radio :label="5">扣款</el-radio>
            <el-radio :label="6">退金（提现）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="金额（元）：" prop="money">
          <el-input v-model="costDealInfo.money" style="width: 300px" placeholder="请输入金额"></el-input>
        </el-form-item>
        <el-form-item label="关联订单号：" prop="orderNo">
          <el-input v-model="costDealInfo.orderNo" style="width:300px" placeholder="请输入关联订单号">
          </el-input>
        </el-form-item>
        <el-form-item label="交易说明：" prop="orderNo">
          <el-input v-model="costDealInfo.dealDesc" style="width:300px" placeholder="请输入交易说明">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="closeCostDealDialog">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="confirmCostDeal">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 费用配置 -->
    <el-dialog title="费用配置" :visible.sync="settingDialogVisible" width="460px" @close="settingDialogClose">
      <el-form :model="settingInfo" :rules="csotSettingRules" ref="settingInfo" label-width="150px" class="demo-replyInfo">
        <el-form-item label="姓名：">
          <span>{{settingInfo.realName}}</span>
        </el-form-item>
        <el-form-item label="用户名：">
          <span>{{settingInfo.userName}}</span>
        </el-form-item>
        <el-form-item label="代购手续费：" prop="serviceRate">
          <div class="lx-flex-row">
            <el-input v-model="settingInfo.serviceRate"></el-input><span class="lx-ml5">%</span>
          </div>

        </el-form-item>
      </el-form>
      <div style="text-align:right;">
        <el-button class="form-btn btn-gray" @click="settingDialogClose">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="settingSave('settingInfo')" size="small">提 交</el-button>
      </div>
    </el-dialog>

    <!-- <MessageTip :visiable.sync="isVisiable" :userName="replyMessageInfo.userName" messageType="其他消息" httpUrl="customer/message" @confirm="onConfirmMsg"></MessageTip> -->
    <MessageTip :visiable.sync="isVisiable" :info="replyMessageInfo" @confirm="onConfirmMsg"></MessageTip>
  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";
import MessageTip from '@/components/MessageTip/index'

export default {
  components: { tableCon, MessageTip },
  data () {
    return {
      fileList: [],
      costDealRole: {
        typeDetail: [
          { required: true, message: "请选择收支类型", trigger: "change" },
        ],
        money: [
          { required: true, message: "请输入金额", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              var reg = /^-?\d{1,16}(?:\.\d{1,2})?$/; //小数点左边最高16位，小数点右边最多2位
              if (reg.test(value)) {
                callback();
              } else {
                callback(new Error("输入正确的数字,小数点后可1到2位"));
              }
            },
            trigger: "blur",
          },
        ],
      },
      hotboomOptions: [
        {
          value: '0',
          label: '关闭'
        }, {
          value: '1',
          label: '开启'
        }
      ],
      isLoading: false,
      rules: {
        remindingTitle: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        remindingContent: [
          { required: true, message: '请输入消息提醒内容', trigger: 'blur' }
        ]
      },
      csotSettingRules: {
        serviceRate: [
          { required: true, message: '请输入FBA手续费', trigger: 'blur' }
        ],
        serviceFee: [
          { required: true, message: '请输入非FBA代购', trigger: 'blur' }
        ]
      },
      queryInfo: {
        userName: "",
        realName: "",
        staffUserId: "",
        pageSize: 10,
        pageNum: 1,
      },
      replyInfo: {
        remindingUserName: '',
        remindingContent: '',
        remindingTitle: '',
        replyPicture: '',
        imgFileList: [],
        imgFileListStr: ''
      },
      settingInfo: {
        userId: '',
        userName: '',
        realName: '',
        serviceRate: '',
      },
      customerList: [],
      replyMessageInfo: {},  //发消息页面显示表格所在行内容
      total: 0,
      distributionInfo: {
        userIds: [],
        staffUserId: "",
      },
      staffList: [],
      selectedStaffList: "",
      distributionVisible: false,
      replyDialogVisible: false,
      settingDialogVisible: false,
      costDealVisible: false,
      costDealInfo: {
        userId: "",
        typeDetail: "",
        money: "",
        orderNo: "",
        dealDesc: ""
      },
      listObj: [],
      imgDataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
        timeStamp: ''
      },
      isVisiable: false, // 消息提醒弹框
    };
  },
  methods: {
    // 修改会员等级
    setLevel(row){
      console.log(row)
      this.$modalDialog(() => import('./DialogLevel.vue'), {
        row
      }).then(
          res => {
            console.log(res)
            this.getCustomerList();
          },
          res => {
            console.log(res)
          }
      )
    },
    costDeal (row) {
      this.costDealDialongInit();
      this.costDealInfo.userId = row.userId;
      this.costDealVisible = true;
      let _this = this;
      this.$nextTick(function () {
        _this.$refs.costDealForm.clearValidate();
      });
    },
    costDealDialogClose () { },
    costDealDialongInit () {
      this.costDealInfo.userId = "";
      this.costDealInfo.typeDetail = "";
      this.costDealInfo.money = "";
      this.costDealInfo.orderNo = "";
      this.costDealInfo.dealDesc = "";
    },
    closeCostDealDialog () {
      this.costDealVisible = false;
    },
    confirmCostDeal () {
      console.log(this.costDealInfo);
      var my = this;
      //保存按钮
      this.$refs.costDealForm.validate(async function (valid) {
        if (valid) {
          //新增和编辑
          var url = "customer/costDeal";
          const { data: res } = await my.$http.post(url, my.costDealInfo);
          if (res.code == 200) {
            my.$message({
              type: "success",
              message: res.message,
            });
            my.getCustomerList();
            my.costDealVisible = false;
          } else {
            my.$message({
              type: "warning",
              message: res.message,
            });
          }
        }
      });
    },
    searchCustomer () {
      this.queryInfo.pageNum = 1;
      this.queryInfo.pageSize = 10;
      this.getCustomerList();
    },
    async changeStatus (row) {
      let status = "";
      if (row.userFlag == "1") {
        status = "0";
      } else {
        status = "1";
      }
      const { data: res } = await this.$http.post("/customer/usable", {
        userId: row.userId,
        userFlag: status,
      });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.message,
        });
        this.getCustomerList();
      } else {
        this.$message.error(res.message);
      }
    },
    async changeHotboomFlag (row) {
      let status = "";
      if (row.hotboomFlag == "1") {
        status = "0";
      } else {
        status = "1";
      }
      const { data: res } = await this.$http.post("/customer/hotboomFlag", {
        userId: row.userId,
        hotboomFlag: status,
      });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.message,
        });
        this.getCustomerList();
      } else {
        this.$message.error(res.message);
      }
    },
    async confirmDistribution () {
      const { data: res } = await this.$http.post(
        "/customer/distribution",
        this.distributionInfo
      );
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.message,
        });
      } else {
        this.$message.error(res.message);
      }
      this.distributionVisible = false;
      this.getCustomerList();
    },
    closeDistributionDialog () {
      this.distributionVisible = false;
    },
    distributionDialogClose () { },
    async getStaffs () {
      const { data: res } = await this.$http.get(
        "emp/empSystemManage/listAll"
      );
      this.staffList = res.data;
      console.log(this.staffList);
    },
    tableSelect (selection, row) {
      this.tableSelectAll(selection);
    },
    tableSelectAll (selection) {
      this.distributionInfo.userIds = [];
      selection.forEach((item) => {
        this.distributionInfo.userIds.push(item.userId);
      });
    },
    distribution () {
      this.distributionInfo.staffUserId = "";
      if (this.distributionInfo.userIds.length > 0) {
        this.getStaffs();
        this.distributionVisible = true;
      } else {
        this.$message({
          type: "warning",
          message: "请先选择用户",
        });
      }
    },
    dateFormatYMDHMS (row, column) {
      var dateStr = row[column.property];
      if (dateStr != null) {
        var date = new Date(parseInt(dateStr) * 1000);
        return (
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) +
          "-" +
          date.getDate() +
          " " +
          date.getHours() +
          ":" +
          date.getMinutes() +
          ":" +
          date.getSeconds()
        );
      }
      return "";
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    statusFormatter (row, column) {
      if (row.userFlag == 0) {
        return "启用";
      } else {
        return "禁用";
      }
    },
    hotboomFormatter (row, column) {
      if (row.hotboomFlag == 0) {
        return "关闭";
      } else {
        return "开启";
      }
    },
    handleSizeChange (pageSize) {
      this.queryInfo.pageSize = pageSize;
      this.getCustomerList();
    },
    handleCurrentChange (pageNumber) {
      this.queryInfo.pageNum = pageNumber;
      this.getCustomerList();
    },
    clearConditions () {
      this.queryInfo = {
        userName: '',
        userId: '',
        staffUserId: ''
      }
      this.distributionInfo = {
        userIds: [],
        staffUserId: ''
      }
      this.$refs.multipleTable.clearSelection();
    },
    async exportAction () {
      this.$http({
        url: '/customer/exportAction',
        method: 'get',
        params: this.queryInfo,
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          //接口参数
        }
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = '用户列表.xlsx';
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch((err) => {
        console.log(err);
      })
    },
    async getCustomerList () {
      this.isLoading = true
      const { data: res } = await this.$http.get("customer/customerList", {
        params: this.queryInfo,
      });
      this.customerList = res.data.list;
      this.total = res.data.total;
      this.isLoading = false
    },
    async addCostSet () {
      var url = 'customer/costSet';
      const { data: res } = await this.$http.post(url, this.settingInfo);
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
        this.getCustomerList()
      }
      else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    settingSave (formName) {    //保存消息提醒内容按钮
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addCostSet();
          this.settingDialogVisible = false;
        } else {
          this.$message.error('必填项不能为空，请重新填写并提交！');
          return false;
        }
      });
    },

    initReplyForm () {   //初始化消息提醒弹窗的内容
      this.replyInfo = {
        remindingContent: '',
        remindingTitle: '',
        replyPicture: ''
      };
    },
    //消息提醒
    reply (row) {
      this.replyMessageInfo = row;
      this.isVisiable = true
    },
    onConfirmMsg() {
      this.isVisiable = false
    },

    costSetting (row) {     //费用配置
      this.settingDialogVisible = true;
      this.settingInfo = {
        id: row.id,
        userId: row.userId,
        userName: row.userName,
        realName: row.realName,
        serviceRate: row.serviceRate,
      }
    },
    settingDialogClose () {    //关闭消息提醒弹窗
      this.settingDialogVisible = false;
    },
  },

  created () {
    this.getCustomerList();
    this.getStaffs();
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
.form-icon{
  cursor: pointer;
}
.pop-flex{
  display: flex;
  span{
    width: 160px;
    text-align: right;
    display: block;
  }
}
.oneStr {
  display: block;
  white-space: nowrap; /* 确保文本在一行内显示 */
  overflow: hidden; /* 隐藏超出容器的内容 */
  text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
  width: 140px!important; /* 设置容器宽度 */
}
// .el-dialog{
//   height: 80% !important;
//   overflow: auto !important;
// }
</style>
